import { Column, Row } from 'Components/Grid';
import { Controller } from 'react-hook-form';
import { ButtonForm } from 'Components/Form/styles';
import { useQuery } from 'react-query';
import { getCompanies } from 'services/company-service';
import { useTranslation } from 'react-i18next';
import { Select } from 'Components/ui';

export const Managers = ({ handleBack, handleComplete, control, handleSubmit, getValues, idCompany }) => {
  const { t } = useTranslation(['company']);

  const onSubmit = () => {
    handleComplete();
  };

  const { data: companies, isLoading: isLoadingCompanies } = useQuery(['getCompanies'], async () => {
    const result = await getCompanies();
    return result?.data.length > 0
      ? idCompany
        ? result?.data.filter(company => company._id !== idCompany)
        : result?.data
      : [];
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Row justifyContent="center">
        <Column xs={12} className="d-flex">
          <Controller
            control={control}
            name="managers"
            rules={{
              validate: () => getValues('managers')?.length > 0,
              required: t('company:companies.form.managersRequired'),
            }}
            render={({ field: { onChange, value }, fieldState }) => (
              <Select
                name="managers"
                label={t('company:companies.form.managers')}
                multiple
                value={isLoadingCompanies ? [] : (Array.isArray(value) ? value : [])}
                onChange={onChange}
                options={(companies || []).map((item) => ({ value: item, label: item.name }))}
                disabled={isLoadingCompanies}
                error={!!fieldState.error}
                helperText={fieldState.error ? fieldState.error.message : ''}
                sx={{ marginBottom: '24px' }}
              />
            )}
          />
        </Column>
      </Row>
      <Row justifyContent="end" alignItems="center">
        <Column xs={4} md={3} className="d-flex" style={{ gap: '8px', justifyContent: 'flex-end' }}>
          <ButtonForm variant="secondary" id="back" onClick={handleBack}>{t('company:companies.form.back')}</ButtonForm>
          <ButtonForm type="submit">{t('company:companies.form.save')}</ButtonForm>
        </Column>
      </Row>
    </form>
  );
};
